import { Link } from "gatsby";
import React from "react";
import Bio from "../components/bio";
import Layout from "../components/layout";
import SEO from "../components/seo";

var BlogIndex = function BlogIndex(_ref) {
  var _data$site, _data$site$siteMetada;

  var data = _ref.data,
      location = _ref.location;
  var siteTitle = ((_data$site = data.site) === null || _data$site === void 0 ? void 0 : (_data$site$siteMetada = _data$site.siteMetadata) === null || _data$site$siteMetada === void 0 ? void 0 : _data$site$siteMetada.title) || "Title";
  var posts = data.allMarkdownRemark.nodes;

  if (posts.length === 0) {
    return /*#__PURE__*/React.createElement(Layout, {
      location: location,
      title: siteTitle
    }, /*#__PURE__*/React.createElement(SEO, {
      title: "All posts"
    }), /*#__PURE__*/React.createElement(Bio, null), /*#__PURE__*/React.createElement("p", null, "No blog posts found. Add markdown posts to \"content/blog\" (or the directory you specified for the \"gatsby-source-filesystem\" plugin in gatsby-config.js)."));
  }

  return /*#__PURE__*/React.createElement(Layout, {
    location: location,
    title: siteTitle
  }, /*#__PURE__*/React.createElement(SEO, {
    title: "All posts"
  }), /*#__PURE__*/React.createElement(Bio, null), /*#__PURE__*/React.createElement("ol", {
    style: {
      listStyle: "none"
    }
  }, posts.map(function (post) {
    var _post$frontmatter, _post$fields, _post$fields2, _post$fields3, _post$frontmatter2, _post$frontmatter3;

    var title = ((_post$frontmatter = post.frontmatter) === null || _post$frontmatter === void 0 ? void 0 : _post$frontmatter.title) || ((_post$fields = post.fields) === null || _post$fields === void 0 ? void 0 : _post$fields.slug);
    return /*#__PURE__*/React.createElement("li", {
      key: (_post$fields2 = post.fields) === null || _post$fields2 === void 0 ? void 0 : _post$fields2.slug
    }, /*#__PURE__*/React.createElement("article", {
      className: "post-list-item",
      itemScope: true,
      itemType: "http://schema.org/Article"
    }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement(Link, {
      to: ((_post$fields3 = post.fields) === null || _post$fields3 === void 0 ? void 0 : _post$fields3.slug) || "",
      itemProp: "url"
    }, /*#__PURE__*/React.createElement("span", {
      itemProp: "headline"
    }, title))), /*#__PURE__*/React.createElement("small", null, (_post$frontmatter2 = post.frontmatter) === null || _post$frontmatter2 === void 0 ? void 0 : _post$frontmatter2.date)), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: ((_post$frontmatter3 = post.frontmatter) === null || _post$frontmatter3 === void 0 ? void 0 : _post$frontmatter3.description) || post.excerpt || ""
      },
      itemProp: "description"
    }))));
  })));
};

export default BlogIndex;
export var pageQuery = "2239478271";